import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTrashAlt,
  faEdit,
  faMinusCircle,
  faQuestionCircle,
  faBars,
  faChevronUp,
  faChevronCircleUp,
  faChevronRight,
  faChevronLeft,
  faExternalLinkAlt,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import {
  setParams,
  submitFundsToAnalyze,
  clearSelectedFunds,
} from "../../actions/actions";
import "./App.css";
import FundSelector from "../FundSelector/FundSelector.js";
import FundList from "../FundList/FundList.js";
import History from "../History/History.js";
import { openInNewTab } from "../../functions/functions.js";

// Initialize the Font Awesome library
library.add(
  faTrashAlt,
  faEdit,
  faMinusCircle,
  faQuestionCircle,
  faBars,
  faChevronUp,
  faChevronCircleUp,
  faChevronRight,
  faChevronLeft,
  faExternalLinkAlt,
  faCircleNotch
);

class App extends PureComponent {
  constructor(props) {
    super(props);
    this.fundSelector = React.createRef();

    // set initial tickers from hash
    const hash = props.history.location.hash.substring(1);
    if (hash !== "") {
      const hash = props.history.location.hash.substring(1).split("&");
      if (
        hash.length > 1 &&
        (hash[0] === "capgains" || hash[0] === "capital-gains-comparison")
      ) {
        if (hash[1].includes("tickers")) {
          const tickers = hash[1].split("tickers=")[1];
          if (tickers.length > 0) {
            props.params.initialTickers = tickers.split(",");
          }
        }
      }
    }
  }

  componentWillUpdate() {
    if (this.props.fundData.selectedFunds) {
      this.fundSelector.current.updateSelectedFunds(
        this.props.fundData.selectedFunds
      );
      this.props.clearSelectedFunds();
    }
  }

  setParams(param) {
    this.props.setParams(param);
  }

  render() {
    return (
      <div className="app-capgains">
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-sm-12">
            <div className="introtext">
              Capital gain distributions from an ETF result from the Fund
              selling securities at a gain, and are distributed on a per share
              basis each December. This tool provides information on estimated
              capital gains for selected US ETFs and Mutual Funds where the data
              is available from the fund issuer. It will be updated from October
              to December as capital gains estimates are released.
            </div>
            <div className="introtext">
              This is an educational tool that you can use to look up capital
              gains estimates. WisdomTree does not recommend any funds and this
              information should not be considered as an offer or solicitation
              with respect to the purchase or sale of any security. The
              information provided is not intended for trading purposes, and
              should not be considered investment advice. This tool should not
              be used as the primary basis for your investment decisions.
            </div>
            <div className="introtext">
              <strong>
                These estimates may be subject to significant change; the
                information presented here isn’t final.
              </strong>
            </div>
            <div className="introtext">
              WisdomTree plans to provide final distributions for all WisdomTree
              Funds in early December 2026.{" "}
              {/* <a
                href='#'
                onClick={() => {
                  openInNewTab('https://www.wisdomtree.com/investments/resource-library/2022-estimated-capital-gains-distributions')
                }}
              >
                Visit 2022 Capital Gains Distributions to learn more.
              </a> */}
            </div>
            <div className="introtext">Please keep in mind the following:</div>
            <div className="introtext">
              Short-term capital gains, long-term capital gains, and ordinary
              income are taxed at different rates. Please consult a tax advisor
              regarding your specific tax situation. Prospective investors
              should consider purchasing shares after the record date in order
              to avoid a tax liability on gains their shares did not earn. You
              should not make investment decisions based on the information
              found here. Investors should consult their legal, tax and
              financial advisors before making any financial decisions.
            </div>
            <div className="introtext">
              This tool will compare funds provided by the user to a relevant
              set of WisdomTree ETFs using a proprietary categorization process
              developed by WisdomTree. This categorization process assigns to
              each US domiciled fund, a category based on the fund's region,
              market capitalization, currency exposure, factor exposures, and
              industry sector characteristics. Using this categorization, for
              each category that WisdomTree has an ETF, funds provided by the
              user are mapped to one or more WisdomTree ETFs. This functionality
              can be disabled by turning off{" "}
              <strong>Show similar WisdomTree funds</strong>.
            </div>
          </div>
        </div>
        {/* <div className="introtext" id='top-of-app'>
                    Access our award-winning <a href='#' onClick={() => {openInNewTab('https://www.wisdomtree.com/advisor-solutions/portfolio-construction-services')}}>Digital Portfolio Developer (DPD)</a> for further fund analysis, stress testing, and more.
                    <div className="version">{"V"+this.props.params.version}</div>
                </div> */}
        {/* Create the FundSelector and pass in the method to call when the ANALYZE button is pressed 
                    The currentFunds array is a list of externalIDs that shouldn't show up in the typeahead
                    as they are already in use */}
        <FundSelector
          submitFundsToAnalyze={this.props.submitFundsToAnalyze}
          typeaheadUrl={
            this.props.params.dpdApiUrl + "api/securityfund/typeahead/"
          }
          tickerNamesUrl={
            this.props.params.dataspanApiUrl + "capgains/ticker_names/"
          }
          wtRegion={this.props.params.wtRegion}
          initialTickers={this.props.params.initialTickers}
          currentFunds={this.props.fundData.fundsToCompare.map((fund) => {
            return fund.inputFund.externalID;
          })}
          ref={this.fundSelector}
        />
        <FundList />
        <History />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    params: state.params,
    fundData: state.fundData,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    setParams,
    submitFundsToAnalyze,
    clearSelectedFunds,
  })(App)
);
